var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnutilizedData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1125 10.812L35.1125 15.812C35.9621 16.2341 36.4995 17.1008 36.5 18.0495V29.962C36.4995 30.9106 35.9621 31.7773 35.1125 32.1995L25.1125 37.1995C24.4083 37.5518 23.5792 37.5518 22.875 37.1995L12.875 32.1995C12.0262 31.7718 11.4934 30.8998 11.5 29.9495V18.0495C11.5005 17.1008 12.0379 16.2341 12.8875 15.812L22.8875 10.812C23.5883 10.4637 24.4117 10.4637 25.1125 10.812Z",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 16.7002L24 22.7502L36.1 16.7002",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.45V22.75",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.75 13.375L30.25 19.625",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnutilizedData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unutilizedData.970d4897c12379138ffb274e2937facd.svg";